import React from 'react'

import { colors } from '@flowwai-frontend/shared/style-guide'

import { IconPropsType } from '../types'

function PaddedChevronDownIcon(props: IconPropsType) {
   const { width = 20, height = 20, stroke = colors['gray-500'] } = props

   return (
      <svg
         width={width}
         height={height}
         fill='none'
         xmlns='http://www.w3.org/2000/svg'
         {...props}
      >
         <path
            d='m5 7.5 5 5 5-5'
            stroke={stroke}
            strokeWidth={1.5}
            strokeLinecap='round'
            strokeLinejoin='round'
         />
      </svg>
   )
}

export { PaddedChevronDownIcon }
